export default {"src":"/_next/static/media/Minnesota.a0fcea74.svg","height":607,"width":800,"blurWidth":0,"blurHeight":0};